import { ArrowUpRight } from "lucide-react";
import { scrollToId } from "../../lib/lenis";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-ink text-bone border-t border-bone/10">
      <div className="max-w-[1600px] mx-auto px-5 sm:px-8 lg:px-12 pt-20 lg:pt-28 pb-10">
        <div className="flex flex-col lg:flex-row justify-between gap-12 pb-16 border-b border-bone/10">
          <div className="max-w-2xl">
            <p className="font-mono text-[10px] uppercase tracking-[0.35em] text-beige mb-6">Begin your story</p>
            <h2 className="font-serif tracking-tight leading-[1.05] text-4xl sm:text-5xl lg:text-6xl">
              We love building homes <em className="italic text-beige">& relationships.</em>
            </h2>
            <a
              data-testid="footer-contact-link"
              href="https://innovationmodularsystem.in/contact"
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-flex items-center gap-3 mt-10 border border-bone/30 rounded-full pl-7 pr-3 py-3 text-xs font-mono uppercase tracking-[0.25em] hover:bg-bone hover:text-ink transition-colors duration-300"
            >
              Book a consultation
              <span className="w-8 h-8 rounded-full bg-bone/15 group-hover:bg-ink/10 flex items-center justify-center transition-transform duration-500 group-hover:translate-x-0.5 group-hover:-translate-y-0.5">
                <ArrowUpRight size={13} strokeWidth={1.5} />
              </span>
            </a>
          </div>

          <div className="flex gap-16 lg:gap-20 lg:pt-12">
            <div>
              <p className="font-mono text-[9px] uppercase tracking-[0.3em] text-bone/40 mb-5">Chapters</p>
              <ul className="space-y-3 text-sm">
                {[["pu", "PU"], ["solidwood", "Solidwood"], ["membrane", "Membrane"], ["laminate", "Laminate"], ["ceramic", "Ceramic"], ["acrylic", "Acrylic"], ["glass", "Toughened Glass"], ["wardrobe", "Wardrobe Shutters"]].map(([id, l]) => (
                  <li key={id}>
                    <button data-testid={`footer-link-${id}`} onClick={() => scrollToId(id)} className="text-bone/70 hover:text-bone transition-colors">
                      {l}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p className="font-mono text-[9px] uppercase tracking-[0.3em] text-bone/40 mb-5">Atelier</p>
              <ul className="space-y-3 text-sm text-bone/70">
                <li>Vasai, Mumbai</li>
                <li>2,50,000 sq ft factory</li>
                <li>
                  <a
                    data-testid="footer-website-link"
                    href="https://innovationmodularsystem.in/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-bone transition-colors"
                  >
                    innovationmodularsystem.in
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="py-14 lg:py-20 overflow-hidden">
          <p className="font-serif tracking-tight leading-none text-[10.5vw] lg:text-[7.2vw] whitespace-nowrap text-bone/95 select-none">
            Innovation <em className="italic text-beige">Modular</em> System
          </p>
        </div>

        <div className="flex flex-col sm:flex-row justify-between gap-4 border-t border-bone/10 pt-8">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-bone/40">
            © 2026 Innovation Modular System · Since 2009
          </p>
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-bone/40">
            European craft · Indian soul · Made in India
          </p>
        </div>
      </div>
    </footer>
  );
}
